import { Component, OnInit } from '@angular/core';
import { MatDialog ,MatDialogConfig } from '@angular/material/dialog';
import { PrivilegeService } from "./../staff/Shared/privilege.service";

// Reports
import { PopupheaderComponent } from "./../loan/shared/popupheader/popupheader.component";
import { RptloanpopupComponent } from './../loan/shared/popup/rptloanpopup/rptloanpopup.component';
import { RptloanapplicationpopupComponent } from './../loan/shared/popup/rptloanapplicationpopup/rptloanapplicationpopup.component';
import { RptloanapprovalpopupComponent } from './../loan/shared/popup/rptloanapprovalpopup/rptloanapprovalpopup.component';
import { RptloanledgerpopupComponent } from './../loan/shared/popup/rptloanledgerpopup/rptloanledgerpopup.component';
import { RptloanoutstandingpopupComponent } from './../loan/shared/popup/rptloanoutstandingpopup/rptloanoutstandingpopup.component';
import { RptloanreceiptpopupComponent } from './../loan/shared/popup/rptloanreceiptpopup/rptloanreceiptpopup.component';
import { RptloansanctionpopupComponent } from './../loan/shared/popup/rptloansanctionpopup/rptloansanctionpopup.component';
import { RptcustomerpopupComponent } from './../customer/shared/popup/rptcustomerpopup/rptcustomerpopup.component';
import { RptcollectionsheetpopupComponent } from './../loan/shared/popup/rptcollectionsheetpopup/rptcollectionsheetpopup.component';
import { RptdemandsheetpopupComponent } from './../loan/shared/popup/rptdemandsheetpopup/rptdemandsheetpopup.component';
import { RptpassbookpopupComponent } from './../loan/shared/popup/rptpassbookpopup/rptpassbookpopup.component';
import { RptloanemipopupComponent } from './../loan/shared/popup/rptloanemipopup/rptloanemipopup.component';
import { RptddfundpopuppComponent } from './../loan/shared/popup/rptddfundpopupp/rptddfundpopupp.component';
import { RptinstallmentpopupComponent } from './../loan/shared/popup/rptinstallmentpopup/rptinstallmentpopup.component';
import { RptledgerpopupComponent } from './../loan/shared/popup/rptledgerpopup/rptledgerpopup.component';
import { RptcashbookpopupComponent } from "../accounts/reports/popup/rptcashbookpopup/rptcashbookpopup.component";
import { RptdaybookpopupComponent } from "../accounts/reports/popup/rptdaybookpopup/rptdaybookpopup.component";
import { RptdaybookcentrepopupComponent } from "../accounts/reports/popup/rptdaybookcentrepopup/rptdaybookcentrepopup.component";
import { RpttrailbalancepopupComponent } from "../accounts/reports/popup/rpttrailbalancepopup/rpttrailbalancepopup.component";

@Component({
  selector: 'app-menunormal',
  templateUrl: './menunormal.component.html',
  styleUrls: ['./menunormal.component.css']
})

export class MenunormalComponent implements OnInit {

  MainmenuList: any[] = [];
  SubmenuList: any[] = [];
  DesignationId :number;

  constructor(public dialog: MatDialog,private privilegeService: PrivilegeService) { }

  ngOnInit() {

    // need to check, while login time.
    // checking User is Live or logout
    if(!localStorage.getItem("IsLoggedIn"))     
      this.SelectPrivilegeByRole(JSON.parse(localStorage.getItem("EmployeeData"))["RoleId"]);

    this.GetLoginUserDetails();  
  }

  // It is not required , Now it is defined in menu normal component.ts
  ViewReports(rptName: any, dummyElement: any): void {

    let retVal: object;

    switch (rptName) {

      case 'loanapplication':
        retVal = RptloanapplicationpopupComponent;
        break;
      case 'loanapproval':
        retVal = RptloanapprovalpopupComponent;
        break;
      case 'loansanction':
        retVal = RptloansanctionpopupComponent;
        break;
      case 'loanreceipt':
        retVal = RptloanreceiptpopupComponent;
        break;
      case 'customers':
        retVal = RptcustomerpopupComponent;
        break;
      case 'collectionsheet':
        retVal = RptcollectionsheetpopupComponent;
        break;
      case 'demandsheet':
        retVal = RptdemandsheetpopupComponent;
        break;
      case 'passbook':
        retVal = RptpassbookpopupComponent;
        break;
      case 'emi':
        retVal = RptloanemipopupComponent;
        break;
      case 'ddfund':
        retVal = RptddfundpopuppComponent;
        break;
      case 'installment':
        retVal = RptinstallmentpopupComponent;
        break;
      case 'Ledger':
        retVal = RptledgerpopupComponent;
        break;
      case 'CashBook':
        retVal = RptcashbookpopupComponent;
        break;
      case 'DayBook':
        retVal = RptdaybookpopupComponent;
        break;
      case 'DayBookCentre':
        retVal = RptdaybookcentrepopupComponent;
        break;
      case 'TrailBalance': 
        retVal = RpttrailbalancepopupComponent;
        break;

    }

    this.openDialog(retVal);
  }

  IdValue: string;
  NameValue: string;
  
  openDialog(componentName: any): void {

  //   const dialogConfig = new MatDialogConfig();

  //   dialogConfig.disableClose = true;
  //   dialogConfig.autoFocus = true;

  //   dialogConfig.position = {
  //     'top': '100',
  //     left: '0'
  // };

    const dialogRef = this.dialog.open(componentName, {
      width: '350px', height: '500px', panelClass: 'modal-dialog',
      autoFocus: false,
      // position: { top: '10px',right:'100px' },
      data: { Id: this.IdValue, Name: this.NameValue }
      
    });

    // dialogRef.updatePosition({
    //   top: '10px',
    //   // right:'10px'
    // });

    // dialogRef.disableClose=false;
  
    dialogRef.afterClosed().subscribe(result => {

      dialogRef.close();
      // console.log(result);
    });
  }

  // Permission checking based on the role in each page!
  SelectPrivilegeByRole(RoleId: any){

        this.privilegeService.GetPrivilegebyRoleId(RoleId).toPromise()
        .then(data => {

          for (let i = 0; i < data.length; i++) {
            if (data[i].DocumentParentId == 0) {  

                this.MainmenuList.push(data[i]);
            }
          }

          for (let i = 0; i < data.length; i++) {
            if (data[i].DocumentParentId != 0) {  

                this.SubmenuList.push(data[i]);
            }
          }
        })
        .catch(err => { console.log(err) });
}

GetLoginUserDetails() {
  this.DesignationId = JSON.parse(localStorage.getItem("EmployeeData"))["DesignationId"];
}

}
